import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import ProjetListByMission from '../projets/ProjectListByMission'
import { useSelector } from 'react-redux'
import { getMissionbyId } from '../../redux/missions/missionActions'
import { AppDispatch, useAppDispatch, RootState } from '../../redux/store'
import BreadcrumbsComponent from '../../components/common/GlobalBreadcrumb'
import { t } from 'i18next'

function ProjectsByMissionId() {
  const { id } = useParams<{ id: string }>()
  const dispatch: AppDispatch = useAppDispatch()

  const Mission = useSelector((state: RootState) => state.mission.mission)
  useEffect(() => {
    if (id) {
      dispatch(getMissionbyId(id))
    }
  }, [dispatch, id])
  const breadcrumbs = [
    {
      label: `Mission ${Mission?.MissionName} `,
      path: `/mission-details/${id}`,
    },
    { label: t('tables.projectTable.title'), path: '' },
  ]

  return (
    <div>
      <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
      <ProjetListByMission IdMission={id || ''} />
    </div>
  )
}

export default ProjectsByMissionId
